export const LINK_WHATSAPP = 'https://api.whatsapp.com/send?phone=555599320906';
export const LINK_INSTAGRAM = '';
export const LINK_YOUTUBE = '';
export const LINK_FACEBOOK = '';
